import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18n';
import { pinRecovery } from 'actions/profile';
import { getContractNumberSelector } from 'reducers/profile/selectors';
import Header from '../common/Header';
import PhoneForm from '../common/PhoneForm';

const i18nScope = 'authorizationRestorePinPhonePage';
const SECTION_NAME = 'PHONE_NUMBER_INPUT';

const AuthorizationRestorePinPhonePage = () => {
  const dispatch = useDispatch();
  const code = '+380';
  const contractNumber = useSelector(getContractNumberSelector);
  const onSubmit = useCallback(
    (values) => {
      dispatch(
        pinRecovery({
          ...values,
          contractNumber,
          errorModal: { returnFocusTo: `@${SECTION_NAME}` },
        }),
      );
    },
    [contractNumber, dispatch],
  );

  return (
    <>
      <Header title={i18n.t(`${i18nScope}.title`)} description={i18n.t(`${i18nScope}.description`)} />
      <PhoneForm
        code={code}
        initialValue={''}
        invalidMessage={i18n.t(`${i18nScope}.phoneInvalid`)}
        analyticsEventGroup={'credentials recovery screen'}
        analyticsEventName={'click send password'}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default AuthorizationRestorePinPhonePage;
